var map = {
	"../../components/customer-features/customerfeatures.module": [
		"./src/app/components/customer-features/customerfeatures.module.ts",
		"common",
		"customerfeatures.module"
	],
	"../../components/customer-reports/report.module": [
		"./src/app/components/customer-reports/report.module.ts",
		"report.module"
	],
	"../../components/loyalty/loyalty.module": [
		"./src/app/components/loyalty/loyalty.module.ts",
		"common",
		"loyalty.module"
	],
	"./components/admin-home/adminHome.module": [
		"./src/app/components/admin-home/adminHome.module.ts",
		"common",
		"adminHome.module"
	],
	"./components/customer-home/home.module": [
		"./src/app/components/customer-home/home.module.ts",
		"common",
		"home.module"
	],
	"./components/merchant-home/merchantHome.module": [
		"./src/app/components/merchant-home/merchantHome.module.ts",
		"common",
		"merchantHome.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main